import { Countries } from "types/Models/countries";
import { string } from "yup";
import { addressAutofill } from "./autofillSchema";

export const directorAutofill = (countries: Countries[] = []) =>
  addressAutofill(countries).shape({
    zipcode: string().required("Zipcode Required"),
    fullName: string().required("Full Name Required"),
    address: string().required("Address Required"),
  });
